export const pinputfield_theme_configuration = {
  root: {
    background: "red",
    color: "unset",
    shadow: "0px 6px 6px 0px rgba(0, 0, 0, 0.0588235294)",
  },
  colorScheme: {
    light: {
      background: "red",
    },
    dark: {
      background: "#010622",
    },
  },
};
